import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import Headers from '@/layout/headers/index.vue';
import HeaderNar from '@/layout/headernar/index.vue';
import Menu from '@/layout/menu/index.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const siderType = computed(() => {
      return store.getters.siderType;
    });
    const asideWidth = computed(() => {
      return store.getters.siderType ? '210px' : '67px';
    });
    // 监听菜单模式
    const menuType = computed(() => {
      if (store.getters.moshiNum === undefined) {
        return localStorage.getItem('changeMoshi') || 1;
      } else {
        return store.getters.moshiNum;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      const _component_RouterView = _resolveComponent("RouterView");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      const _component_el_aside = _resolveComponent("el-aside");
      return _unref(menuType) === '2' ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        class: "app-wrapper",
        style: {
          "overflow-y": "hidden",
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, null, {
          default: _withCtx(() => [_createVNode(Headers)]),
          _: 1
        }), _createVNode(HeaderNar), _createVNode(_component_el_main, {
          style: {
            "/* background-color": "#f2f7ff",
            "*/\r\n          padding": "10px 16px",
            "margin-top": "5px",
            "overflow-y": "hidden",
            "height": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_RouterView)]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_container, {
        key: 1,
        class: "app-wrapper",
        style: {
          "overflow-y": "hidden",
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: _unref(asideWidth),
          class: "sidebar-container"
        }, {
          default: _withCtx(() => [_createVNode(Menu)]),
          _: 1
        }, 8, ["width"]), _createVNode(_component_el_container, {
          class: _normalizeClass(["container", {
            hidderContainer: !_unref(siderType)
          }])
        }, {
          default: _withCtx(() => [_createVNode(_component_el_header, null, {
            default: _withCtx(() => [_createVNode(Headers)]),
            _: 1
          }), _createVNode(HeaderNar), _createVNode(_component_el_main, {
            style: {
              "/* background-color": "#f2f7ff",
              "*/\r\n          padding": "10px 16px",
              "/* margin-top": "5px",
              "*/\r\n          overflow-y": "hidden",
              "height": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_RouterView)]),
            _: 1
          })]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      }));
    };
  }
});